export const SET_APPLICATIONS = "SET_APPLICATIONS";
export const ADD_APPLICATION = "ADD_APPLICATION";
export const REMOVE_APPLICATION = "REMOVE_APPLICATION";